<template></template>

<script>
import axios from "@/axios";
import moment from "moment-timezone";

export default {
    //antes de mostrar la vista debe validarse que este firmante ya ha terminado de firmar todos sus controles del tramite
    async beforeCreate(){
        var zone_name = moment.tz.guess()
        // var timezone = moment.tz(zone_name).zoneAbbr()
        var timezone2 = moment().format("ZZ")
        var timezone3 = timezone2.slice(0, 3)
        axios.post('api/firmante/obtener-token-temporal/', {
            token_firmante: this.$route.query.firm,
            time_zone         : timezone3,
            time_stamp        : Date.now()
        }).then(response => {
            if(response.data.status == "success"){
                if(response.data.puede_firmar){
                    this.$router.push({name: 'firma', params: { id: this.$route.params.id, token_temporal: response.data.token_temporal }, query: { firm: this.$route.query.firm}});
                }
                else{
                    //mostrar vista de documento ya firmado o no disponible
                    if(!response.data.link_firmado){
                        this.$router.push({ name: 'page-doc-ya-firmado' });
                    }
                    else{
                        this.$router.push({ name: 'page-doc-no-disponible' });
                    }
                }
            }
        });
    },
}
</script>

